module.exports = __webpack_public_path__ + "img/minimize-02.9fc1aa0b.svg";